export default __webpack_public_path__ + "static/media/2.043e48cb.jpg";